import { useRef, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import CaseOptionsCard from "components/CaseOptions";

const MenuCell: FC<Props> = ({ element }) => {
  const [showOptions, setShowOptions] = useState(false);
  const refWrapper = useRef<HTMLDivElement>(null);

  return (
    <div className={styles.cell}>
      <div
        onClick={() => {
          setShowOptions(!showOptions);
        }}
        ref={refWrapper}
        className={styles.hover}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </div>
      <CaseOptionsCard
        showDropdown={false}
        showOptions={showOptions}
        showSomething={true}
        pack={element}
        refetch={() => {}}
        refWrapper={refWrapper}
        onClickEdit={() => {}}
        onClickAttachIcon={() => {}}
        toggle={() => {
          setShowOptions(false);
        }}
        setShowThreads={() => {}}
        showThreads={false}
        selectedElements={[]}
        setSelectedElements={() => {}}
        dropdown={true}
        isRightClicked={false}
      />
    </div>
  );
};

export default MenuCell;
